webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var MILLIARDS = {
    label: "milliards",
    chiffres: [{
        label: "C",
        info: " une centaine de milliards",
        coef: 2 + 9
    }, {
        label: "D",
        info: " une dizaine de milliards",
        coef: 1 + 9
    }, {
        label: "U",
        info: " une unité de milliards",
        coef: 9
    }]
};
var MILLIONS = {
    label: "millions",
    chiffres: [{
        label: "C",
        info: " une centaine de millions",
        coef: 2 + 6
    }, {
        label: "D",
        info: " une dizaine de millions",
        coef: 1 + 6
    }, {
        label: "U",
        info: " une unité de million",
        coef: 6
    }]
};
var MILLIERS = {
    label: "milliers",
    chiffres: [{
        label: "C",
        info: " une centaine de milliers",
        coef: 2 + 3
    }, {
        label: "D",
        info: " une dizaine de milliers",
        coef: 1 + 3
    }, {
        label: "U",
        info: " une unité de millier",
        coef: 3
    }]
};
var UNITES = {
    label: "unités",
    chiffres: [{
        label: "C",
        info: " une centaine d'unités",
        coef: 2
    }, {
        label: "D",
        info: " une dizaine d'unités",
        coef: 1
    }, {
        label: "U",
        info: " une unité",
        coef: 0
    }]
};
var PARTIE_DECIMALE = {
    label: "partie décimale",
    chiffres: [{
        color: "C",
        label: "1/10",
        info: " un dixième",
        coef: -1
    }, {
        color: "D",
        label: "1/100",
        info: " un centième",
        coef: -2
    }, {
        color: "U",
        label: "1/1000",
        info: " un millième",
        coef: -3
    }]
};
exports.default = {
    byId: {
        milliards: {
            hash: "#milliards",
            label: "milliards",
            max: Math.pow(10, 12),
            classes: [MILLIARDS, MILLIONS, MILLIERS, UNITES]
        },
        millions: {
            hash: "#millions",
            label: "millions",
            max: Math.pow(10, 9),
            classes: [MILLIONS, MILLIERS, UNITES]
        },
        milliers: {
            hash: "#milliers",
            label: "milliers",
            max: Math.pow(10, 6),
            classes: [MILLIERS, UNITES]
        },
        unites: {
            hash: "#unites",
            label: "unités",
            max: Math.pow(10, 3),
            classes: [UNITES]
        },
        decimaux: {
            hash: "#decimaux",
            label: "partie décimale",
            max: Math.pow(10, 3),
            classes: [UNITES, { label: "coma", chiffres: [{ label: "," }] }, PARTIE_DECIMALE]
        }
    },
    allIds: ["milliards", "millions", "milliers", "unites", "decimaux"]
};

/***/ }),
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(5);

var _reactDom2 = _interopRequireDefault(_reactDom);

__webpack_require__(19);

__webpack_require__(20);

var _app = __webpack_require__(21);

var _app2 = _interopRequireDefault(_app);

var _config = __webpack_require__(3);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sanitizeHash = function sanitizeHash() {
    var _document$location$ha = document.location.hash.match(/^(#(milliards|millions|milliers|unites|decimaux))?(=([0-9]*(\.|,)?[0-9]{0,3}))?/),
        _document$location$ha2 = _slicedToArray(_document$location$ha, 5),
        _document$location$ha3 = _document$location$ha2[2],
        hash = _document$location$ha3 === undefined ? "milliers" : _document$location$ha3,
        _document$location$ha4 = _document$location$ha2[4],
        egal = _document$location$ha4 === undefined ? 0 : _document$location$ha4;

    var intervalle = _config2.default.byId[hash];
    var valeur = egal !== 0 ? egal.toString().replace(",", ".") : 0;
    var nombre = {
        valeur: valeur < intervalle.max ? Math.floor(valeur * 1000) : 0,
        max: intervalle.max * 1000
    };
    document.location.hash = intervalle.hash;
    return {
        intervalle: intervalle,
        nombre: nombre
    };
};

_reactDom2.default.render(_react2.default.createElement(_app2.default, { title: "Compteur" }), document.querySelector("#app"));

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 20 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _navbar = __webpack_require__(22);

var _navbar2 = _interopRequireDefault(_navbar);

var _choix = __webpack_require__(23);

var _choix2 = _interopRequireDefault(_choix);

var _compteur = __webpack_require__(24);

var _compteur2 = _interopRequireDefault(_compteur);

var _config = __webpack_require__(3);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getHash = function getHash() {
    var _document$location$ha = document.location.hash.match(/^(#(milliards|millions|milliers|unites|decimaux))?(=([0-9]*([\.,][0-9]{1,3})?))?/),
        _document$location$ha2 = _slicedToArray(_document$location$ha, 5),
        _document$location$ha3 = _document$location$ha2[2],
        hashChoix = _document$location$ha3 === undefined ? "milliers" : _document$location$ha3,
        _document$location$ha4 = _document$location$ha2[4],
        hashNombre = _document$location$ha4 === undefined ? 0 : _document$location$ha4;

    var intervalle = _config2.default.byId[hashChoix];
    var nombre = hashNombre !== 0 ? hashNombre.toString().replace(",", ".") : 0;

    document.location.hash = "#" + hashChoix;
    return {
        choix: hashChoix,
        nombre: nombre < intervalle.max ? nombre : 0
    };
};
var initialCompteur = getHash();

exports.default = function (_ref) {
    var title = _ref.title;

    var _useState = (0, _react.useState)(initialCompteur),
        _useState2 = _slicedToArray(_useState, 2),
        compteur = _useState2[0],
        setCompteur = _useState2[1];

    var updateCompteur = function updateCompteur(_ref2) {
        var type = _ref2.type,
            payload = _ref2.payload;

        switch (type) {
            case "CHANGE_CHOIX":
                setCompteur({
                    choix: payload,
                    nombre: 0
                });
                document.location.hash = "#" + payload;
                break;
            case "INCREMENT":
                var next = Math.round(compteur.nombre * 1000 + Math.pow(10, payload + 3));
                setCompteur(_extends({}, compteur, {
                    nombre: next < _config2.default.byId[compteur.choix].max * 1000 ? next / 1000 : compteur.nombre
                }));
                break;
            case "DECREMENT":
                var prev = Math.round(compteur.nombre * 1000 - Math.pow(10, payload + 3));
                setCompteur(_extends({}, compteur, {
                    nombre: prev >= 0 ? prev / 1000 : compteur.nombre
                }));
                break;
            default:
                break;
        }
    };

    var handleUpdateChoix = function handleUpdateChoix(_ref3) {
        var choix = _ref3.choix;

        updateCompteur({ type: "CHANGE_CHOIX", payload: choix });
    };
    var handleUpdateNombre = function handleUpdateNombre(_ref4) {
        var action = _ref4.action,
            coef = _ref4.coef;

        updateCompteur({ type: action, payload: coef });
    };

    return _react2.default.createElement(
        "div",
        { className: "container" },
        _react2.default.createElement(_navbar2.default, { title: title }),
        _react2.default.createElement(
            "div",
            { className: "row" },
            _react2.default.createElement(
                "div",
                { className: "row mb-3" },
                _react2.default.createElement(_choix2.default, {
                    choix: compteur.choix,
                    updateChoix: handleUpdateChoix
                })
            ),
            _react2.default.createElement(
                "div",
                { className: "row" },
                _react2.default.createElement(_compteur2.default, {
                    compteur: compteur,
                    updateNombre: handleUpdateNombre
                })
            )
        )
    );
};

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

__webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var title = _ref.title;
    return _react2.default.createElement(
        "nav",
        { className: "navbar navbar-inverse navbar-fixed-top", role: "navigation" },
        _react2.default.createElement(
            "div",
            { className: "navbar-header" },
            _react2.default.createElement(
                "a",
                {
                    className: "navbar-brand text-white",
                    href: "https://micetf.fr",
                    title: "Des Outils Pour La Classe"
                },
                "MiCetF"
            ),
            _react2.default.createElement(
                "button",
                {
                    type: "button",
                    className: "navbar-toggle",
                    "data-toggle": "collapse",
                    "data-target": "#navbarMobile"
                },
                _react2.default.createElement(
                    "span",
                    { className: "sr-only" },
                    "Toggle navigation"
                ),
                _react2.default.createElement("span", { className: "icon-bar" }),
                _react2.default.createElement("span", { className: "icon-bar" }),
                _react2.default.createElement("span", { className: "icon-bar" })
            )
        ),
        _react2.default.createElement(
            "div",
            { className: "collapse navbar-collapse", id: "navbarMobile" },
            _react2.default.createElement(
                "div",
                { className: "nav navbar-nav" },
                _react2.default.createElement(
                    "span",
                    { className: "navbar-brand text-white" },
                    ">"
                ),
                _react2.default.createElement(
                    "span",
                    { className: "navbar-brand text-white" },
                    title
                )
            ),
            _react2.default.createElement(
                "div",
                { className: "navbar-right mr-2" },
                _react2.default.createElement(
                    "ul",
                    { className: "nav navbar-nav pull-left" },
                    _react2.default.createElement(
                        "li",
                        { className: "mr-2" },
                        _react2.default.createElement(
                            "form",
                            {
                                action: "https://www.paypal.com/cgi-bin/webscr",
                                method: "post",
                                target: "_top"
                            },
                            _react2.default.createElement(
                                "button",
                                {
                                    className: "btn btn-link navbar-btn",
                                    title: "Si vous pensez que ces outils le m\xE9ritent... Merci !",
                                    type: "submit"
                                },
                                _react2.default.createElement("span", { className: "glyphicon glyphicon-heart" })
                            ),
                            _react2.default.createElement("input", { type: "hidden", name: "cmd", value: "_s-xclick" }),
                            _react2.default.createElement("input", {
                                type: "hidden",
                                name: "hosted_button_id",
                                value: "Q2XYVFP4EEX2J"
                            })
                        )
                    ),
                    _react2.default.createElement(
                        "li",
                        { className: "mr-2" },
                        _react2.default.createElement(
                            "a",
                            {
                                className: "btn btn-link",
                                title: "Chercher un outil sur micetf.fr...",
                                href: "https://micetf.fr/outils",
                                target: "_blank"
                            },
                            _react2.default.createElement("span", { className: "glyphicon glyphicon-search" })
                        )
                    ),
                    _react2.default.createElement(
                        "li",
                        null,
                        _react2.default.createElement(
                            "a",
                            {
                                className: "btn btn-link",
                                title: "Pour contacter le webmaster...",
                                href: "mailto:webmaster@micetf.fr?subject=Au sujet de /Compteur"
                            },
                            _react2.default.createElement("span", { className: "glyphicon glyphicon-envelope" })
                        )
                    )
                )
            )
        )
    );
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(3);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var choix = _ref.choix,
        updateChoix = _ref.updateChoix;

    var handleClick = function handleClick(e, next) {
        e.preventDefault();
        updateChoix({ choix: next });
    };
    var renderChoix = function renderChoix(id) {
        var active = choix === id ? "active" : "";
        var _config$byId$id = _config2.default.byId[id],
            hash = _config$byId$id.hash,
            label = _config$byId$id.label;

        return _react2.default.createElement(
            "a",
            {
                key: id,
                href: hash,
                className: "btn btn-primary " + active,
                onClick: function onClick(e) {
                    return handleClick(e, id);
                }
            },
            label
        );
    };
    return _react2.default.createElement(
        "div",
        { className: "row" },
        _react2.default.createElement(
            "div",
            { className: "btn-group btn-group-justified" },
            _config2.default.allIds.map(renderChoix)
        )
    );
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _config = __webpack_require__(3);

var _config2 = _interopRequireDefault(_config);

var _classe = __webpack_require__(25);

var _classe2 = _interopRequireDefault(_classe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (_ref) {
    var _ref$compteur = _ref.compteur,
        choix = _ref$compteur.choix,
        nombre = _ref$compteur.nombre,
        updateNombre = _ref.updateNombre;

    var renderClasse = function renderClasse(classe) {
        return _react2.default.createElement(
            "div",
            { className: "classe " + classe.label, key: classe.label },
            _react2.default.createElement(_classe2.default, {
                classe: classe,
                nombre: nombre,
                updateNombre: updateNombre
            })
        );
    };
    return _react2.default.createElement(
        "div",
        { className: "compteur" },
        _config2.default.byId[choix].classes.map(renderClasse)
    );
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _chiffre = __webpack_require__(26);

var _chiffre2 = _interopRequireDefault(_chiffre);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderLabelClasse = function renderLabelClasse(label) {
    if (label === "coma") {
        return _react2.default.createElement(
            "p",
            { className: "label invisible" },
            " "
        );
    }
    return _react2.default.createElement(
        "p",
        { className: "label label-info" },
        label
    );
};

exports.default = function (_ref) {
    var classe = _ref.classe,
        nombre = _ref.nombre,
        updateNombre = _ref.updateNombre;

    var renderChiffre = function renderChiffre(chiffre, index) {
        return _react2.default.createElement(_chiffre2.default, {
            key: index,
            chiffre: chiffre,
            nombre: nombre,
            updateNombre: updateNombre
        });
    };
    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "div",
            { className: "classe-header" },
            renderLabelClasse(classe.label)
        ),
        _react2.default.createElement(
            "div",
            { className: "chiffres" },
            classe.chiffres.map(renderChiffre)
        )
    );
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderComa = function renderComa() {
    return _react2.default.createElement(
        "div",
        { className: "chiffre" },
        _react2.default.createElement(
            "p",
            { className: "label invisible" },
            ","
        ),
        _react2.default.createElement(
            "div",
            { className: "affichage" },
            _react2.default.createElement(
                "button",
                { className: "btn btn-primary invisible" },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-up" })
            ),
            _react2.default.createElement(
                "div",
                { className: "digit" },
                ","
            ),
            _react2.default.createElement(
                "button",
                { className: "btn btn-primary invisible" },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-down" })
            )
        )
    );
};

exports.default = function (_ref) {
    var chiffre = _ref.chiffre,
        nombre = _ref.nombre,
        updateNombre = _ref.updateNombre;
    var coef = chiffre.coef,
        color = chiffre.color,
        label = chiffre.label,
        info = chiffre.info;

    var handleClick = function handleClick(action) {
        return function (e) {
            e.preventDefault();
            updateNombre({ coef: coef, action: action });
        };
    };
    if (label === ",") {
        return renderComa();
    }
    var p10 = Math.pow(10, coef + 3);
    var digit = Math.floor(Math.round(nombre * 1000) % (p10 * 10) / p10);
    return _react2.default.createElement(
        "div",
        { className: "chiffre" },
        _react2.default.createElement(
            "p",
            { className: "label label-" + (color || label) },
            label
        ),
        _react2.default.createElement(
            "div",
            { className: "affichage" },
            _react2.default.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: handleClick("INCREMENT"),
                    title: "Ajouter " + info
                },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-up" })
            ),
            _react2.default.createElement(
                "div",
                { className: "digit" },
                digit
            ),
            _react2.default.createElement(
                "button",
                {
                    className: "btn btn-primary",
                    onClick: handleClick("DECREMENT"),
                    title: "Enlever " + info
                },
                _react2.default.createElement("span", { className: "glyphicon glyphicon-chevron-down" })
            )
        )
    );
};

/***/ })
],[8]);


// WEBPACK FOOTER //
// js/main.bundle.js